import React, { useState, useEffect } from 'react';
import styles from "../../styles.module.scss";
import AButton from '../../../../../common/form-fields-mui/AButton';
import CancelCollectionDialog from '../../dialogs/CancelCollectionDialog';
import VerifyDetailsDialog from '../../dialogs/VerifyDetailsDialog';
import CreatingReceiptDailog from '../../dialogs/CreatingReceiptDialog';
import { fetchAllPostPromisedData, httpPostCall } from '../../../../../common/utils/methods/commonMethods/utilityMethod';
import { endpoint } from '../../../../../common/constant';
import { getFormatedDate } from '../../../../concessionApproval/common';
import ReceiptCreationInProcessDialog from '../../dialogs/ReceiptCreationInProcessDialog';
import { DataRow } from './StudentDetails';
import { ReactComponent as DangerWarning } from "../../../../../../../../assets/img/svg/DangerWarningYellow.svg";
import { getCreateReceiptReqObj } from '../../../utils';
import { failureToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import ReceiptCreationSuccessDialog from '../../dialogs/ReceiptCreationSuccessDialog';

const labelFieldMapping = [
    { label: 'Acknowledgement ID', field: "acknowledgementId" },
    { label: 'Date & Time', field: "dateAndTime" },
]

const ReceiptDetails = ({
    studentBasicDetails,
    selectedCharges,
    collectPayment,
    amountToBePaid,
    studentDetails,
    collectVoucherList,
    state,
    setState,
    module,
    createReceipt,
    partialAddAmount
}) => {

    const [reciptState, setReceiptState] = useState('not_verified');
    const [receiptDetails, setReceiptDetails] = useState(null);
    const [dialogOpen, setDialogOpen] = useState({});

    const dialogCloseHandler = () => {
        setDialogOpen({});
    }

    const createReceiptClickHandler = async () => {

        try {

            setDialogOpen({ creatingReceiptDialogOpen: true });

            const resp = await createReceipt(
                state,
                {...studentBasicDetails, partialAddAmount},
                amountToBePaid,
                selectedCharges,
                collectPayment,
                collectVoucherList
            )


            if (resp?.code === 200) {
                const { acknowledgementId, receiptNumber } = resp?.data?.paymentCollectionResponse ?? {};
                setReceiptDetails({
                    acknowledgementId,
                    receiptNumber,
                    dateAndTime: getFormatedDate(new Date(), true),
                })
                if (receiptNumber) {
                    setReceiptState("created");
                    setDialogOpen({ receiptCreationSuccessDialogOpen: true })
                } else {
                    setReceiptState("creation_in_process");
                    setDialogOpen({ receiptCreationInProcessDialogOpen: true })
                }
                setState(state)
            }
            else if (resp?.code === 412) {
                failureToast(resp?.message)
                setTimeout(function () {
                    window.location.reload();
                }, 4000);
                return;
            }
            else {
                dialogCloseHandler();
            }

        } catch (err) {
            console.error(err);
            dialogCloseHandler();
        }
    }

    return (
        <>
            {receiptDetails &&
                <>
                    <div className={`mb-2 ${styles['review-details-row-value']}`}>Receipt Details</div>
                    {labelFieldMapping?.map(el =>
                        <DataRow key={el?.label} label={el?.label} value={receiptDetails?.[el?.field]} />
                    )}
                </>

            }

            {reciptState === 'not_verified' &&
                <div className='d-flex justify-content-between'>
                    <AButton
                        variant='outline'
                        className='no-ml-btn w-50'
                        onClick={() => setDialogOpen({ cancelCollectionDialogOpen: true })}
                    >
                        Cancel
                    </AButton>

                    <AButton
                        variant='outline'
                        className='w-50'
                        onClick={() => setDialogOpen({ verifyDetailsDialogOpen: true })}
                    >
                        Verify Receipt
                    </AButton>

                </div>
            }

            {reciptState === 'verified' &&
                <AButton
                    variant='primary_filled'
                    className='no-ml-btn w-100'
                    onClick={createReceiptClickHandler}
                >
                    Create Receipt
                </AButton>
            }

            {reciptState === 'creation_in_process' &&
                <div className={`mt-3 ${styles['receipt-creation-in-process-info']}`}>
                    <DangerWarning className='mr-1' />
                    Receipt is getting generated.
                    <span onClick={() => setDialogOpen({ receiptCreationInProcessDialogOpen: true })}>Know more</span>
                </div>
            }

            {['created', 'creation_in_process']?.includes(reciptState) &&
                <AButton
                    variant='primary_filled'
                    className='no-ml-btn w-100 mt-3'
                    disabled={reciptState === 'creation_in_process'}
                    onClick={() => { }}
                >
                    Print Receipt
                </AButton>
            }

            <CancelCollectionDialog
                open={!!dialogOpen?.cancelCollectionDialogOpen}
                closeHandler={dialogCloseHandler}
                confirmHandler={() => { }}
            />

            <VerifyDetailsDialog
                open={!!dialogOpen?.verifyDetailsDialogOpen}
                closeHandler={dialogCloseHandler}
                confirmHandler={() => {
                    setReceiptState('verified');
                    dialogCloseHandler();
                }}
                module={module}
            />

            <CreatingReceiptDailog
                open={!!dialogOpen?.creatingReceiptDialogOpen}
            />

            <ReceiptCreationInProcessDialog
                open={!!dialogOpen?.receiptCreationInProcessDialogOpen}
                closeHandler={() => { window.location.reload() }}
                mobNo={studentDetails?.studentMobileNumber}
                emailId={studentDetails?.studentEmailId}
            />

            <ReceiptCreationSuccessDialog
                open={!!dialogOpen?.receiptCreationSuccessDialogOpen}
                pserpReceiptId={receiptDetails?.receiptNumber}
                closeHandler={() => { window.location.reload() }}
            />
        </>
    );
}

export default ReceiptDetails;